import script from "./FileUpload2.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUpload2.vue?vue&type=script&setup=true&lang=js"

import "./FileUpload2.vue?vue&type=style&index=0&id=3d948d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d948d3a"]])

export default __exports__